import $axios from '../api.js';

const state = () => ({
    tos: [],
    tos_data: {
        id: '',
        code: '',
        name: '',
        content: '',
        tos_version_published: {
            id: '',
            tos_type_id: '',
            content: '',
            published_at: '',
        },
    },
    loading: {
        button: false,
        screen: false,
        pagination: false,
    },
});

const mutations = {
    SET_TOS(state, payload) {
        state.tos = payload;
    },
    SET_TOS_DETAIL(state, payload) {
        state.tos_data = payload;
    },
};

const actions = {
    getTos({ commit }) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/tos')
                .then(response => {
                    commit('SET_TOS', response.data.responseData);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    getTosDetail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios
                .get('/tos/' + payload)
                .then(response => {
                    commit('SET_TOS_DETAIL', response.data.responseData);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
